import { toNormalizedMessage } from '@/shared/utils/sentry/clientIgnoreRules/stringMatchers';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

const URI_ERROR_MESSAGE = 'uri error';
const UWT_FILENAME = 'uwt.js';
const SELLER_UI_APP_FRAME_MARKERS = [
  'webpack://_n_e/./src/',
  'webpack://_n_e/src/',
  '/_next/static/chunks/',
] as const;

const hasUriErrorMessage = (message: unknown): boolean =>
  toNormalizedMessage(message) === URI_ERROR_MESSAGE;

const hasUwtStackFrame = (stackFrameFilenames: string[]): boolean =>
  stackFrameFilenames.some((filename) =>
    toNormalizedMessage(filename)?.includes(UWT_FILENAME)
  );

const hasSellerUiAppStackFrame = (stackFrameFilenames: string[]): boolean =>
  stackFrameFilenames.some((filename) => {
    const normalizedFilename = toNormalizedMessage(filename);

    return Boolean(
      normalizedFilename &&
      SELLER_UI_APP_FRAME_MARKERS.some((marker) =>
        normalizedFilename.includes(marker)
      )
    );
  });

export const thirdPartyUwtUriErrorRule: ClientSentryIgnoreRule = {
  id: 'third-party-uwt-uri-error',
  references: ['FTR-2680', 'FTR-2699'],
  reason:
    'Known third-party UWT decodeURIComponent browser noise outside seller-ui app code',
  matches: ({
    firstExceptionType,
    originalExceptionMessage,
    serializedMessage,
    stackFrameFilenames,
  }) => {
    if (firstExceptionType !== 'URIError') {
      return false;
    }

    if (
      !hasUriErrorMessage(serializedMessage) &&
      !hasUriErrorMessage(originalExceptionMessage)
    ) {
      return false;
    }

    if (hasSellerUiAppStackFrame(stackFrameFilenames)) {
      return false;
    }

    return hasUwtStackFrame(stackFrameFilenames);
  },
};
